import React, { useState } from 'react'

import clsx from 'clsx'

import Avatar from 'components/Avatar'
import Icon from 'components/Icon'
import Lightbox from 'components/Lightbox'
import Logo from 'components/Logo'
import NextImage from 'components/NextImage'
import Typography from 'components/Typography'
import YoutubeVideo from 'components/YoutubeVideo'
import { useEventContext } from 'context/EventContext'
import { formatAvatarInitials } from 'helpers/formatters'
import useViewport from 'hooks/useViewport'

import classes from './UserVerdict.module.scss'

const VERDICT_LISTING_MIN_SIZE = 32

/** @type {import("./types").default} */
const UserVerdict = ({ listing = {}, videoReview = {}, listingImageSize = VERDICT_LISTING_MIN_SIZE }) => {
  const { reviewer = {}, video_source = {} } = videoReview
  const [lightboxState, setLightboxState] = useState({ toggler: false })
  const { up } = useViewport()
  const { addEvent, sendEvent } = useEventContext()
  const avatarName = formatAvatarInitials(reviewer.user_name) || 'AR'

  const handleOnClose = () => {
    sendEvent({
      engagementDetails: 'video',
      engagementDestination: 'close-media',
      name: 'engagement_product_click',
    })
  }

  const lightboxToggleHandler = () => {
    setLightboxState({
      toggler: !lightboxState.toggler,
    })
  }

  return (
    <div className="UserVerdict">
      <div className={classes.veredictDetails}>
        <div className={classes.typographySpacing}>
          <Avatar src={reviewer.profile_picture_url} className={classes.userAvatar}>
            <Typography variant="tight-xxs">{avatarName}</Typography>
          </Avatar>
        </div>
        <Icon icon={['ga', 'caret']} className={classes.gaCaret} />
        <div className={classes.logoContainer}>
          <Logo src={listing.logo_url} fetchWidth={listingImageSize} alt="product-logo" />
        </div>
      </div>
      <div className={classes.textBlock}>
        <Typography variant="body-xs">
          <b> {reviewer.user_name || 'Anonymous Reviewer'} </b>
          {'chose ' + listing.name}
        </Typography>
      </div>
      <div className={clsx(classes.video)}>
        {up('md') ? (
          <>
            <div style={{ position: 'relative' }}>
              <NextImage
                src={`https://img.youtube.com/vi/${video_source.videoId}/mqdefault.jpg`}
                width={278}
                height={156}
                onClick={lightboxToggleHandler}
                alt="video-thumbnail"
                {...addEvent({
                  engagementDetails: 'video',
                  engagementDestination: 'open-media',
                  name: 'engagement_product_click',
                })}
              />
              <Icon
                icon="play-circle"
                prefix="far"
                className={classes.playIcon}
                size="48"
                onClick={lightboxToggleHandler}
                {...addEvent({
                  engagementDetails: 'video',
                  engagementDestination: 'open-media',
                  name: 'engagement_product_click',
                })}
              />
            </div>
            <Lightbox
              onClose={handleOnClose}
              openOnMount
              sources={[`youtube.com/watch?v=${video_source.videoId}`]}
              toggler={lightboxState.toggler}
            />
          </>
        ) : (
          <YoutubeVideo video={{ videoId: video_source.videoId }} />
        )}
      </div>
    </div>
  )
}

export default UserVerdict
